export function checkResponseStatus(response: Response) {
  const isOK = response.status >= 200 && response.status < 300;

  if (!isOK) {
    throw new Error(response.statusText);
  }
}
